import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { privacyPolicy, termsOfUse } from '@/mock/mock-footer'

export function Footer() {
  const [openPrivacidade, setOpenPrivacidade] = useState(false)
  const [openTermos, setOpenTermos] = useState(false)

  const dataAtual = '26/06/2025'

  return (
    <footer className="text-muted-foreground mt-10 p-4 text-center text-sm">
      <div>DIGICAP &copy; rifaqui.com.br - {new Date().getFullYear()}</div>

      <div className="mt-2 flex flex-wrap justify-center gap-4">
        {/* Política de Privacidade */}
        <Dialog open={openPrivacidade} onOpenChange={setOpenPrivacidade}>
          <DialogTrigger asChild>
            <Button
              variant="link"
              className="h-auto p-0 text-green-600 hover:text-green-700"
            >
              Política de Privacidade
            </Button>
          </DialogTrigger>
          <DialogContent className="max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>📄 Política de Privacidade – RIFAQUI</DialogTitle>
            </DialogHeader>
            <div className="text-muted-foreground space-y-4 text-sm">
              <p>
                <strong>Última atualização:</strong> {dataAtual}
              </p>
              {privacyPolicy.map((item, idx) => (
                <div key={idx}>
                  <p className="font-semibold">{item.title}</p>
                  {item.description && (
                    <p className="whitespace-pre-line">{item.description}</p>
                  )}
                </div>
              ))}
            </div>
          </DialogContent>
        </Dialog>

        {/* Termos de Uso */}
        <Dialog open={openTermos} onOpenChange={setOpenTermos}>
          <DialogTrigger asChild>
            <Button
              variant="link"
              className="h-auto p-0 text-green-600 hover:text-green-700"
            >
              Termo de Responsabilidade
            </Button>
          </DialogTrigger>
          <DialogContent className="max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>📄 Termos de Uso – RIFAQUI</DialogTitle>
            </DialogHeader>
            <div className="text-muted-foreground space-y-4 text-sm">
              <p>
                <strong>Última atualização:</strong> {dataAtual}
              </p>
              {termsOfUse.map((item, idx) => (
                <div key={idx}>
                  <p className="font-semibold">{item.title}</p>
                  {item.description && (
                    <p className="whitespace-pre-line">{item.description}</p>
                  )}
                </div>
              ))}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </footer>
  )
}
